<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.4149 5L11.9436 3.66649C11.8054 3.2754 11.4323 3 11 3C10.5677 3 10.1946 3.2754 10.0564 3.66649L9.58506 5H7C5.89543 5 5 5.89543 5 7V15C5 16.1046 5.89543 17 7 17H15C16.1046 17 17 16.1046 17 15V7C17 5.89543 16.1046 5 15 5H12.4149ZM8.17071 3H7C4.79086 3 3 4.79086 3 7V15C3 17.2091 4.79086 19 7 19H15C17.2091 19 19 17.2091 19 15V7C19 4.79086 17.2091 3 15 3H13.8293C13.4175 1.83481 12.3062 1 11 1C9.69378 1 8.58254 1.83481 8.17071 3Z"
    fill="currentColor"
  />
  <path
    d="M9 17C8.44772 17 8 17.4477 8 18V20C8 20.5523 8.44772 21 9 21C9.55228 21 10 20.5523 10 20V18C10 17.4477 9.55228 17 9 17Z"
    fill="currentColor"
  />
  <path
    d="M14 18C14 17.4477 13.5523 17 13 17C12.4477 17 12 17.4477 12 18V20C12 21.6569 13.3431 23 15 23H20C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21H15C14.4477 21 14 20.5523 14 20V18Z"
    fill="currentColor"
  />
  <path
    d="M15 8C14.4477 8 14 8.44771 14 9C14 9.55229 14.4477 10 15 10H18C18.5523 10 19 9.55229 19 9C19 8.44771 18.5523 8 18 8H15Z"
    fill="currentColor"
  />
  <path
    d="M15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14H18C18.5523 14 19 13.5523 19 13C19 12.4477 18.5523 12 18 12H15Z"
    fill="currentColor"
  />
</svg>
